import React, {useEffect, useRef} from 'react'
import ReactDOM from 'react-dom/client'
import {useAccessToken} from '@salesforce/commerce-sdk-react'
import useCustomFetch from '../../../../hooks/useFetchContent'
import {Box, Skeleton} from '@salesforce/retail-react-app/app/components/shared/ui'

import {homeTopBrandsContainerStyles, homeTopBrandsPlaceholderStyle} from './index.style'
import SliderInitiator from '../../../../components/slider-initiator'
import {HOME_CONTENT_SLOTS} from '../../../../constants'

const slotIDs = HOME_CONTENT_SLOTS.TOP_BRANDS

const HomeTopBrands = () => {
    const {token} = useAccessToken()
    const {response, loading, error} = useCustomFetch(token, slotIDs, true)
    const boxRef = useRef(null)

    const settings = {
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        centerMode: true,
        centerPadding: '66px', //keeping px value as rem values are not considering by react slick for width calculations
        slidesToScroll: 1,
        autoplay: false,
        responsive: [
            {
                breakpoint: 1023,
                settings: {
                    centerPadding: '30px' //keeping px value as rem values are not considering by react slick for width calculations
                }
            },
            {
                breakpoint: 767,
                settings: {
                    arrows: false,
                    slidesToShow: 2,
                    centerPadding: '60px' //keeping px value as rem values are not considering by react slick for width calculations
                }
            },
            {
                breakpoint: 575,
                settings: {
                    arrows: false,
                    slidesToShow: 1
                }
            }
        ]
    }

    useEffect(() => {
        if (boxRef.current && response) {
            const slideContainers = boxRef.current.querySelectorAll('.spring-styles-slider')

            slideContainers.forEach((container) => {
                const slideElements = container.querySelectorAll('.slide-item')
                if (slideElements.length > 1) {
                    const slidesArray = Array.from(slideElements).map((slide) => slide.outerHTML)
                    container.innerHTML = '' // Clear the static slider content

                    // Use createRoot to render the slider component into the container
                    const root = ReactDOM.createRoot(container)
                    root.render(<SliderInitiator slidesHtml={slidesArray} settings={settings} />)
                }
            })
        }
    }, [response])

    if (error) return

    if (loading) return <Skeleton sx={homeTopBrandsPlaceholderStyle} />

    if (!response) return

    return (
        <Box
            ref={boxRef}
            data-content-tracking="home_top_brands"
            sx={homeTopBrandsContainerStyles}
            dangerouslySetInnerHTML={{__html: response}}
        />
    )
}

export default HomeTopBrands
